export default __webpack_public_path__ + "static/media/pic4.d4f49a64.jpg";